import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../Pages/style.css';

import ContactImage from '../Images/contact.jpg';
import PhoneIcon from '../Images/phone.png';
import EmailIcon from '../Images/email.png';
import AddressIcon from '../Images/address.png';
import Footer from '../Pages/Footer';

const Contact = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = `${e.target.firstName.value} ${e.target.lastName.value}`;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const message = e.target.message.value;

    try {
      await fetch("https://docs.google.com/forms/d/e/1FAIpQLSeEwcpyww9vM74dRwQ4x3nsKp9RWotYwmY0aY1wJpqJZb0uuA/formResponse", {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:
          "entry.72610541=" + encodeURIComponent(name) +
          "&entry.834634778=" + encodeURIComponent(email) +
          "&entry.1456370932=" + encodeURIComponent(phone) +
          "&entry.1850985828=" + encodeURIComponent(message)
      });

      alert("Message submitted successfully!");
      e.target.reset();
    } catch (error) {
      alert("Error submitting form");
      console.error(error);
    }
  };

  useEffect(() => {
    if (window.location.hostname === 'mindronmeditech.com') {
      window.location.href = 'https://www.mindronmeditech.com' + window.location.pathname + window.location.search;
    }

    AOS.init({ duration: 1000, once: false });

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    boxSizing: 'border-box',
    outline: 'none',
    fontFamily: 'sans-serif',
    color: '#333',
    background: '#fff',
  };

  const labelStyle = {
    fontSize: '13px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '6px',
    display: 'block',
  };

  const markerStyle = {
    width: isMobile ? '8px' : '12px',
    height: isMobile ? '8px' : '12px',
    backgroundColor: 'red',
    borderRadius: '50%',
    border: '2px solid white',
    marginBottom: '4px',
  };

  const labelStyles = {
    color: '#003366',
    fontSize: isMobile ? '10px' : '12px',
    backgroundColor: 'white',
    padding: '2px 4px',
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  };

  return (
    <>
      <Helmet>
        <title>Contact Mindron Meditech | Medical Equipment Company in Mumbai</title>
        <meta
          name="description"
          content="Contact Mindron Meditech Pvt. Ltd. for medical devices, diagnostic equipment, healthcare technology solutions, product support, and medical equipment inquiries in Mumbai."
        />
        <link rel="canonical" href="https://www.mindronmeditech.com/contact" />
      </Helmet>

      <div style={{ fontFamily: 'sans-serif', overflowX: 'hidden', color: '#222' }}>

        {/* HERO */}
        <div style={{
          position: 'relative',
          width: '100%',
          height: isMobile ? '30vh' : '80vh',
          overflow: 'hidden',
        }}>
          <img
            src={ContactImage}
            alt="Contact"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to top, rgba(0,20,60,0.5) 0%, transparent 60%)',
          }} />
        </div>

        {/* CONTACT US HEADING */}
        <div style={{ padding: isMobile ? '32px 6% 0' : '48px 6% 0' }}>
          <div style={{ width: '50px', height: '5px', backgroundColor: '#cc0000', borderRadius: '2px', marginBottom: '10px' }} />
          <h1 style={{ fontSize: isMobile ? '24px' : '32px', fontWeight: '800', color: '#0a1628', margin: 0 }}>
            CONTACT US
          </h1>
        </div>

        {/* MAIN CONTENT: Contact Info + Form */}
        <div style={{
          display: 'flex',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          gap: '40px',
          padding: isMobile ? '28px 6%' : '40px 6%',
          alignItems: 'flex-start',
        }}>

          {/* LEFT: Contact Details */}
          <div style={{ flex: '0 0 auto', width: isMobile ? '100%' : '340px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#0a1628', margin: '0 0 24px' }}>
              Corporate Headquarter
            </h2>

            {/* Phone */}
            <div style={{ display: 'flex', gap: '14px', marginBottom: '20px', alignItems: 'flex-start' }}>
              <img src={PhoneIcon} alt="Phone" style={{ width: '28px', height: '28px', marginTop: '2px' }} />
              <div style={{ fontSize: '15px', color: '#333', lineHeight: '1.8' }}>
                +91 86559 72632<br />
                +91 86559 72633<br />
                022 4516 6539
              </div>
            </div>

            {/* Email */}
            <div style={{ display: 'flex', gap: '14px', marginBottom: '20px', alignItems: 'flex-start' }}>
              <img src={EmailIcon} alt="Email" style={{ width: '28px', height: '28px', marginTop: '2px' }} />
              <div style={{ fontSize: '15px', color: '#333' }}>
                info@mindronmeditech.com
              </div>
            </div>

            {/* Address */}
            <div style={{ display: 'flex', gap: '14px', marginBottom: '24px', alignItems: 'flex-start' }}>
              <img src={AddressIcon} alt="Address" style={{ width: '28px', height: '28px', marginTop: '2px' }} />
              <div style={{ fontSize: '15px', color: '#333', lineHeight: '1.7' }}>
                <strong>Mindron Meditech Private Limited</strong><br />
                Unit No. 218, 2nd Floor, D Block,<br />
                Agra Road Industrial Premises Co-op.<br />
                Society Ltd., Amrut Nagar Road,<br />
                Ghatkopar West, Mumbai - 400086, India
              </div>
            </div>

            {/* Map */}
            <div style={{ width: '100%', height: '220px', borderRadius: '10px', overflow: 'hidden', position: 'relative' }}>
              <iframe
                title="Mindron Meditech Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.126400966925!2d72.9114937749781!3d19.10210998210786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c782963cbc57%3A0xe3a4a8bd76446b13!2sMindron%20Meditech%20Private%20limited!5e0!3m2!1sen!2sin!4v1747806779929!5m2!1sen!2sin"
                style={{ width: '100%', height: '100%', border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <a
                href="https://www.google.com/maps/dir//Mindron+Meditech+Private+limited"
                target="_blank"
                rel="noopener noreferrer"
                style={{ position: 'absolute', inset: 0, zIndex: 2 }}
              />
            </div>
          </div>

          {/* RIGHT: Form */}
          <div style={{ flex: 1, minWidth: '260px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#0a1628', margin: '0 0 24px' }}>
              Get in Touch
            </h2>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

              {/* Full Name */}
              <div>
                <label style={labelStyle}>Full Name</label>
                <div style={{ display: 'flex', gap: '12px', flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                  <input
                    name="firstName"
                    type="text"
                    placeholder="First Name"
                    style={inputStyle}
                    required
                    onChange={e => { e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, ''); }}
                  />
                  <input
                    name="lastName"
                    type="text"
                    placeholder="Last Name"
                    style={inputStyle}
                    required
                    onChange={e => { e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, ''); }}
                  />
                </div>
              </div>

              {/* Phone Number */}
              <div>
                <label style={labelStyle}>Phone Number</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <select style={{ ...inputStyle, width: '90px', flexShrink: 0 }}>
                    <option value="+91">+91</option>
                    <option value="+1">+1</option>
                    <option value="+44">+44</option>
                    <option value="+852">+852</option>
                    <option value="+61">+61</option>
                  </select>
                  <input
                    name="phone"
                    type="tel"
                    placeholder="Phone Number"
                    style={inputStyle}
                    required
                    pattern="[0-9]{10}"
                    title="Phone number must be exactly 10 digits"
                    onInput={e => { e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10); }}
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label style={labelStyle}>Email</label>
                <input
                  name="email"
                  type="email"
                  placeholder="Email Address"
                  style={inputStyle}
                  required
                />
              </div>

              {/* Address */}
              <div>
                <label style={labelStyle}>Address</label>
                <input
                  name="address"
                  type="text"
                  placeholder="Your Address"
                  style={inputStyle}
                />
              </div>

              {/* Message */}
              <div>
                <label style={labelStyle}>Share Your Message</label>
                <textarea
                  name="message"
                  placeholder="Message"
                  style={{ ...inputStyle, minHeight: '100px', resize: 'vertical' }}
                  required
                />
              </div>

              <button
                type="submit"
                style={{
                  padding: '12px',
                  fontSize: '15px',
                  fontWeight: '700',
                  backgroundColor: '#001F54',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}
                onMouseEnter={e => e.target.style.backgroundColor = '#003399'}
                onMouseLeave={e => e.target.style.backgroundColor = '#001F54'}
              >
                Submit
              </button>
            </form>
          </div>
        </div>

        {/* WORLD MAP */}
        <div style={{
          position: 'relative',
          width: '100%',
          maxWidth: '1500px',
          margin: isMobile ? '30px auto' : '70px auto',
          padding: '0 6%',
          boxSizing: 'border-box',
        }}>
          <div style={{ position: 'relative', overflow: 'hidden', height: isMobile ? '200px' : '460px' }}>
            <img
              src={require('../Images/worldmap.png')}
              alt="World Map"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                objectPosition: 'center center',
                display: 'block',
                marginBottom: '0',
              }}
            />

            {/* Mumbai */}
            <a
              href="https://www.google.com/maps/place/Mindron+Meditech+Private+limited"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                position: 'absolute',
                top: isMobile ? '60%' : '60%',
                left: isMobile ? '64%' : '65%',
                transform: 'translate(-50%,-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none'
              }}
            >
              <div style={markerStyle} />
              <span style={labelStyles}>Mumbai</span>
            </a>

            {/* Lucknow */}
            <a
              href="https://www.google.com/maps/place/Mukut+Tower"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                position: 'absolute',
                top: isMobile ? '50%' : '55%',
                left: isMobile ? '63%' : '64.5%',
                transform: 'translate(-50%,-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none'
              }}
            >
              <span style={labelStyles}>Lucknow</span>
              <div style={markerStyle} />
            </a>

            {/* Hong Kong */}
            <a
              href="https://www.google.com/maps/place/Hart+Avenue+Plaza"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                position: 'absolute',
                top: isMobile ? '38%' : '42%',
                left: isMobile ? '80%' : '79%',
                transform: 'translate(-50%,-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none'
              }}
            >
              <span style={labelStyles}>Hong Kong</span>
              <div style={markerStyle} />
            </a>

            {/* New York */}
            <a
              href="https://www.google.com/maps/place/20+W+47th+St"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                position: 'absolute',
                top: isMobile ? '34%' : '40%',
                left: isMobile ? '27%' : '26%',
                transform: 'translate(-50%,-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none'
              }}
            >
              <span style={labelStyles}>New York</span>
              <div style={markerStyle} />
            </a>
          </div>
        </div>

        {/* LOCATION FOOTER BANNER */}
        {/* <div style={{
          backgroundColor: '#003366',
          padding: isMobile ? '28px 6%' : '36px 6%',
          color: '#fff',
        }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: isMobile ? '24px' : '40px',
          }}>
            {[
              {
                title: 'India - Mumbai',
                address: 'D 218, Mumbai - Agra Road, Industrial Estate, Amrut Nagar, Behind R City Mall, Ghatkopar West, Mumbai, Maharashtra 400086',
                phones: ['022 4516 6539', '+91 86559 72631'],
              },
              {
                title: 'India - Lucknow',
                address: 'Office No. 404, 4th floor, Mukut Tower, Kursi Rd, Sector 2, Vikas Nagar, Lucknow, Uttar Pradesh 226022',
                phones: ['+91 86559 72632', '+91 86559 72633'],
              },
              {
                title: 'USA - New York',
                address: '20 West. 47th Street, 15/F., Suite 1500, New York, NY 10036, USA.',
                phones: ['(001) 212-354-4400', '(001) +917 7535253', '(001) 212-354-4408'],
              },
              {
                title: 'Hong Kong',
                address: 'Room 706, 7/F, Hart Avenue Plaza, 5-9 Hart Avenue, Tsim Sha Tsui, Kowloon, Hong Kong',
                phones: ['(852) 2766 2008', '(852) 66443807', '(852) 2766 2040'],
              },
            ].map((loc, index) => (
              <div key={index} style={{ flex: '1 1 180px', fontSize: '13px', lineHeight: '1.7', color: '#ccd6e8' }}>
                <div style={{ fontWeight: '700', color: '#fff', marginBottom: '8px', fontSize: '14px' }}>{loc.title}</div>
                <div style={{ marginBottom: '8px' }}>{loc.address}</div>
                {loc.phones.map((phone, i) => (
                  <div key={i}>📞 {phone}</div>
                ))}
              </div>
            ))}
          </div>
        </div> */}

        {/* FOOTER */}
        <Footer />

        <style>{`
          *::-webkit-scrollbar { display: none; }
          * { scrollbar-width: none; }
          body { overflow-x: hidden; }
          input:focus, textarea:focus, select:focus {
            outline: 2px solid #001F54;
            border-color: #001F54;
          }
          @media (max-width: 768px) {
            .header-container { height: 30vh !important; }
          }
        `}</style>
      </div>
    </>
  );
};

export default Contact;